module.exports = __webpack_public_path__ + "static/media/ico-sort.7e53c3e8.svg";